import {Component, OnDestroy, OnInit} from '@angular/core';
import gql from 'graphql-tag';
import {HeaderGetMe, HeaderGetMe_me} from './__generated__/HeaderGetMe';
import {Apollo} from 'apollo-angular';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {EMPTY, Subscription} from 'rxjs';
import {ErrorService} from '../../shared/services/error.service';
import {AuthService} from '../../shared/services/auth.service';

const headerGetMeQuery = gql`
    query HeaderGetMe {
      me {
        id
        firstName
        lastName
        photo
      }
    }
`;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  title = '';
  isMenuOpen = false;
  me: HeaderGetMe_me | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private apollo: Apollo,
    private router: Router,
    private errService: ErrorService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.apollo
        .watchQuery<HeaderGetMe>({
          query: headerGetMeQuery,
        })
        .valueChanges.pipe(
          catchError(error => {
            this.errService.handleDefault(error);
            return EMPTY;
          }),
        )
        .subscribe(data => (this.me = data.data?.me ?? null)),
    );
  }

  navigateToProfile(id: string): void {
    this.router.navigate(['user/', id]);
  }

  mailToSupport(): void {
    window.location.href = 'mailto:support@skideo.com';
  }

  logout(): void {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
